'use strict';

exports.__esModule = true;
exports.default = typeof window !== 'undefined' && typeof document !== 'undefined';


//////////////////
// WEBPACK FOOTER
// ./~/react-textarea-autosize/lib/isBrowser.js
// module id = 447
// module chunks = 0